import React, { Component, PropTypes } from 'react';

import S from './style.css';

export default class ButtonIcon extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    iconImage: PropTypes.string.isRequired,
    style: PropTypes.object,
  }

  static defaultProps = {
    className: '',
    style: {},
  }

  render() {
    const {
      children,
      className,
      iconImage,
      style,
      ...rest,
    } = this.props;

    const buttonClasses =
      `${S.button} bn navy app-f7 pt1 cursor-pointer outline-0 ${className}`;
    const buttonStyle = {
      background: `url('${iconImage}') no-repeat left`,
      ...style,
    };

    return (
      <button
        className={buttonClasses}
        style={buttonStyle}
        {...rest}
      >
        {children}
      </button>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/ButtonIcon/index.jsx
 **/